import { Component, Prop } from "vue-property-decorator";
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { ApartmentDTO } from '../../../model/ApartmentDTO';

interface ProjectStatusItem {
	title: string;
	date?: Date;
	showToday?: boolean;
	done?: boolean;
}

@Block() @Component
export class ApartmentProjectStatusBlock extends BaseBlock {
	@Prop() apartment: ApartmentDTO;

	todayDate: Date = new Date();
	expand: boolean = !this.$store.isTouchDevice;
	isTouchDevice: boolean = this.$store.isTouchDevice;

	get housingBlock() {
		return this.apartment.housingBlock;
	}

	get isHousingBlockDone() {
		return new Date(this.apartment.completionDate) < this.todayDate;
	}

	get items(): ProjectStatusItem[] {
		let items: ProjectStatusItem[] = [];

		const startOfSaleItem: ProjectStatusItem = {
			title: "selling-beginning",
			date: this.apartment.startOfSaleDate
				? new Date(this.apartment.startOfSaleDate)
				: null
		};

		items.push({
			title: "construction-beginning",
			date: this.housingBlock.constructionBeginningDate
				? new Date(this.housingBlock.constructionBeginningDate)
				: null
		});

		items.push({
			title: "rough-construction-completion",
			date: this.housingBlock.roughConstructionCompletionDate
				? new Date(this.housingBlock.roughConstructionCompletionDate)
				: null
		});

		items.push({
			title: "final-inspection",
			date: this.housingBlock.finalInspectionDate
				? new Date(this.housingBlock.finalInspectionDate)
				: null
		});

		items.push({
			title: "ready-to-move-in",
			date: this.housingBlock.readyToMoveInDate
				? new Date(this.housingBlock.readyToMoveInDate)
				: null
		});

		// Find position for Start of Sale
		items.splice(this.getIndexByDate(items, startOfSaleItem.date) + 1, 0, startOfSaleItem);

		// Show today mark, if today date is between statuses dates
		const todayIndex = this.getIndexByDate(items, this.todayDate);
		if (todayIndex > -1 && todayIndex < items.length - 1) {
			items[todayIndex].showToday = true;
		}

		// Mark all items with date before today date as done
		items.slice(0, todayIndex + 1).forEach(item => (item.done = true));

		return items;
	}

	// Find index of item, which has the latest date before the input date
	getIndexByDate(items: ProjectStatusItem[], date?: Date) {
		let index = items.length - 1;
		while (index >= 0) {
			if (items[index].date && date && items[index].date < date) {
				break;
			}
			--index;
		}

		return index;
	}
}

export default ApartmentProjectStatusBlock;
